import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react';
import { Animated, Easing, Platform } from 'react-native';

import PropTypes from 'prop-types';

import { Colors } from '../../../Components/Themes';
import Images from '../../Themes/images';

import Styles from './styles';

const MoveSplash = forwardRef((props, ref) => {
  const { color: backgroundColor = Colors.vfRed, logoColor, logoSize } = props;

  const getLogo = desiredColor => (desiredColor === Colors.white ? Images.logo : Images.logoRed);

  const [endX, setEndX] = useState(-140);
  const [endY, setEndY] = useState(-280);
  const logoRef = useRef();
  const backgroundViewRef = useRef();

  const [scaleAnim] = useState(new Animated.Value(1));
  const [translateAnim] = useState(new Animated.Value(0));
  const [backgroundOpacity] = useState(new Animated.Value(1));

  useEffect(() => {
    const key = backgroundOpacity.addListener(({ value }) => {
      changeLogoAndBackgroundColors(parseFloat(value).toFixed(1), key);
    });
  }, [logoColor]);

  const changeLogoAndBackgroundColors = (backgroundOpacityValue, key) => {
    if (backgroundOpacityValue == 0.5) {
      handleChangeLogoColor();
      changeBackgroundZIndex();
    }
    if (backgroundOpacityValue == 0.3) {
      chageBackgroundToTransparent();
      backgroundOpacity.removeListener(key);
    }
  };

  const changeBackgroundZIndex = () => {
    // add zIndex to background so when backgroud opacity goes to 0.5 logo can be visible
    if (backgroundViewRef.current && backgroundViewRef.current.setNativeProps) {
      backgroundViewRef.current.setNativeProps({
        zIndex: 100,
      });
    }
  };

  const setLogoPosition = logoPosition => {
    if (logoPosition && logoPosition.logoX && logoPosition.logoY) {
      setEndX(logoPosition.logoX);
      setEndY(logoPosition.logoY);
    }
  };

  const backgroundFadeAnimation = () => {
    return Animated.sequence([
      Animated.timing(backgroundOpacity, {
        toValue: 0.3,
        duration: 200,
        easing: Easing.bezier(0.58, 1.0, 0.0, 0.0),
        useNativeDriver: true,
      }),
      Animated.timing(backgroundOpacity, {
        toValue: 1,
        useNativeDriver: true,
      }),
    ]);
  };

  const splashAnim = (startAfter = 1000) =>
    Animated.sequence([
      Animated.delay(startAfter),
      Animated.parallel([
        Animated.timing(scaleAnim, {
          toValue: logoSize / Styles.logo.height,
          duration: 600,
          easing: Easing.bezier(0.76, 0.0, 0.24, 1.0),
          useNativeDriver: true,
        }),
        backgroundFadeAnimation(),
        Animated.timing(translateAnim, {
          toValue: 1,
          duration: 600,
          delay: 300,
          easing: Easing.bezier(0.14, 1.0, 0.34, 1.0),
          useNativeDriver: true,
        }),
      ]),
    ]);

  const startSplash = (config = {}, endSplash) => {
    const { _endX = null, _endY = null, startAfter = 1000 } = config;
    if (_endX && _endY) {
      setEndY(_endY);
      setEndX(_endX);
    }

    return new Promise(resolve => {
      splashAnim(startAfter).start(({ finished }) => {
        if (finished) {
          resolve({ dismissSplash: endSplash, done: true });
        }
      });
    });
  };
  const chageBackgroundToTransparent = () => {
    if (backgroundViewRef.current && backgroundViewRef.current.setNativeProps) {
      backgroundViewRef.current.setNativeProps({
        backgroundColor: 'transparent',
      });
    }
  };
  const handleChangeLogoColor = () => {
    if (logoColor === Colors.white) {
      return;
    }

    if (logoRef.current && logoRef.current.setNativeProps) {
      const src = Platform.OS == 'android' ? 'src' : 'source';
      logoRef.current.setNativeProps({
        [src]: [Images.logoRed],
      });
    }
  };

  const translateX = translateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [0, endX],
  });

  const translateY = translateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [0, endY],
  });

  useImperativeHandle(
    ref,
    () => ({
      startSplash: (config, endSplash) => startSplash(config, endSplash),
      setLogoPosition: logoPosition => setLogoPosition(logoPosition),
    }),
    [],
  );

  return (
    <>
      {/* <Animated.View
        ref={backgroundViewRef}
        style={[Styles.container, { opacity: backgroundOpacity, backgroundColor }]}
      />
      <Animated.View style={[{ transform: [{ translateX }, { translateY }] }, Styles.logoWrapper]}>
        <Animated.Image
          ref={logoRef}
          source={getLogo(Colors.white)}
          style={[Styles.logo, { transform: [{ scale: scaleAnim }] }]}
        />
      </Animated.View> */}
    </>
  );
});

MoveSplash.displayName = 'MoveSplash';

MoveSplash.propTypes = {
  color: PropTypes.string,
  logoColor: PropTypes.string,
  logoSize: PropTypes.number,
};

export default MoveSplash;
